@if (!isFileSelected()) {
  <section class="uploader">
    <mat-icon>cloud_upload</mat-icon>
    <strong>Drag & drop image</strong>
    <footer>JPG, PNG - Max size 50MB</footer>
    <input type="file" name="uploader" #fileInput (change)="uploadImageService.upload(fileInput.files, endpoint)" />
  </section>
} @else {
  <section class="uploading">
    <div class="cancel" (click)="cancel()" (keyup.enter)="cancel()" tabindex="-1" matTooltip="Cancel" matTooltipPosition="below">
      <mat-icon inline="true">close</mat-icon>
    </div>
    <div class="file">{{ uploadImageService.file?.name }}</div>

    @if (!isCompleteState()) {
      <mat-progress-bar mode="determinate" [value]="progress()"></mat-progress-bar>
    } @else {
      <div class="complete">File uploaded</div>
    }
    @if (errorMessage) {
      <mat-error>{{ errorMessage }}</mat-error>
    }
  </section>
}
